import { Component, Inject, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { MODAL_DATA } from 'src/app/core/services/modal';
import { Router } from '@angular/router';
import { CompanyService } from 'src/app/core/services/company.service';

export interface IIntroductionFeatureSlide {
  image?: string;
  imageAlt?: string;
  title: string;
  description: string;
  navigatePath?: string | null;
  featureKey?: 'advertisingAMZ' | 'itemsRepricingAMZ';
}

@Component({
  selector: 'app-introduction-feature-modal',
  templateUrl: './introduction-feature-modal.component.html',
  styleUrls: ['./introduction-feature-modal.component.scss'],
})
export class IntroductionFeatureModalComponent implements OnInit {
  slides: IIntroductionFeatureSlide[] = [];

  currentSlideIndex = 0;

  constructor(
    @Inject(MODAL_DATA) public data: any,
    public activeModal: NgbActiveModal,
    private router: Router,
    private companyService: CompanyService
  ) {}

  ngOnInit(): void {
    if (this.data && this.data.slides && this.data.slides.length > 0) {
      this.slides = this.data.slides;
    }
  }

  get currentSlide(): IIntroductionFeatureSlide {
    return this.slides[this.currentSlideIndex];
  }

  saveOnboardingState(): void {
    const currentCompany = this.companyService.currentCompany();
    if (currentCompany) {
      const updatedState = { ...(currentCompany.featureOnboardingState || {}) };
      let hasUpdates = false;
      for (const slide of this.slides) {
        if (slide.featureKey) {
          updatedState[slide.featureKey] = true;
          hasUpdates = true;
        }
      }

      if (hasUpdates) {
        currentCompany.featureOnboardingState = updatedState;
        this.companyService.updateCompanyInfo({
          companyKey: currentCompany.companyKey,
          featureOnboardingState: updatedState
        }).subscribe();
      }
    }
  }

  next(): void {
    if (this.currentSlideIndex < this.slides.length - 1) {
      this.currentSlideIndex++;
      return;
    }

    this.saveOnboardingState();

    if (this.currentSlide.navigatePath !== null && this.currentSlide.navigatePath !== undefined) {
      this.activeModal.close('explore');
      this.router.navigate([this.currentSlide.navigatePath]);
      return;
    }

    this.activeModal.close('explore');
  }

  back(): void {
    if (this.currentSlideIndex > 0) {
      this.currentSlideIndex--;
    }
  }

  goToSlide(index: number): void {
    if (index >= 0 && index < this.slides.length) {
      this.currentSlideIndex = index;
    }
  }

  dismiss(): void {
    this.saveOnboardingState();
    this.activeModal.dismiss('close');
  }
}
